import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ButtonComponent } from '../../components/button/button.component';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../components/table/table.component';
import { LabelChipsComponent } from '../../components/label-chips/label-chips.component';
import { faClockRotateLeft, faCheckCircle, faTimesCircle, faUserHelmetSafety, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconActionComponent } from '../../components/icon-action/icon-action.component';
import { FacturaService } from '../../services/factura.service';
import { DetalleFactura, DocumentoAsociado } from '../../interfaces/documento-factura.interface';
import { CabeceraDetalleFacturaComponent } from './cabecera-detalle-factura/cabecera-detalle-factura.component';
import { ContenidoDocumentoComponent } from './contenido-documento/contenido-documento.component';
import { ContenidoFlujoComponent } from './contenido-flujo/contenido-flujo.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Opciones } from '../../components/input/opciones.interface';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../services/helpers.service';
import { InputComponent } from '../../components/input/input.component';
import { Location } from '@angular/common';
import { AprobacionService } from '../../services/aprobacion.service';
import { TableConfig } from '../../components/table/table-config.interface';
import { HistorialFactura, RespuestaHistorial } from '../../interfaces/historial-factura.interface';
import { AprobadorDisponible } from '../../interfaces/aprobador.interface';
import { RespuestaFlujoAprobacion } from '../../interfaces/flujo-aprobacion.interface';
import { DatosAprobarRechazar } from '../../models/aprobar-rechazar.models';
import { RespuestaAprobarRechazar } from '../../interfaces/aprobar-documento.interface';
import { SnackBarComponent } from '../../components/snack-bar/snack-bar.component';
import { SnackbarStateService } from '../../services/snackbar-state.service';
import { DatosAprobador } from '../../models/aprobador.models';
import { Financieras } from '../../enums/helpers-enum';
import { RespuestaFormaPago } from '../../interfaces/forma-pago.interface';
import { EmpresaService } from '../../services/empresa.service';
import { RespuestaEmpresa } from '../../interfaces/empresa.interface';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-detalle-factura',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, FontAwesomeModule, ButtonComponent, TableComponent, LabelChipsComponent, IconActionComponent, ModalComponent, CabeceraDetalleFacturaComponent, ContenidoDocumentoComponent, ContenidoFlujoComponent, ReactiveFormsModule, InputComponent, SnackBarComponent],
  templateUrl: './detalle-factura.component.html',
  styleUrl: './detalle-factura.component.scss'
})
export class DetalleFacturaComponent {

  @ViewChild('modalTemplateAprobar') modalTemplateAprobar!: TemplateRef<any>;

  public refresSelect$ = new BehaviorSubject<boolean>(false);
  faClockRotateLeft = faClockRotateLeft;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faUserHelmetSafety = faUserHelmetSafety;
  faChevronLeft = faChevronLeft;
  listDocAsociados: DocumentoAsociado[] = [];
  aprobadores: Opciones[] = [];
  formadePago: Opciones[] = [];
  idOrgc: number = 0;
  idDoc: number = 0;
  formulario!: FormGroup;
  formularioEditar!: FormGroup;
  modalAprobar: boolean = false;
  modalRechazar: boolean = false;
  modalHistorial: boolean = false;
  modalFlujo: boolean = false;
  modalEditarFlujo: boolean = false;
  dataDetailFlujo:any;
  //Varaibles SnackBar
  showSnackBar = false;
  typeSnackBar = 'error';
  tituloSnackBar = 'Factura Aprobada';
  mensajeSnackBar = 'La Factura ha sido aprobada con éxito.';
  estadoSemaforo = '';
  estiloEstadoSemaforo = '';
  mostrarSelectFormaPago:boolean = false;
  flujoAprobacion: any = {};
  detalleFact: any = {};
  IdFormaPago:number = 3;
  public refresSelectInputSelect = new BehaviorSubject<boolean>(false);

  dataConfigHistory: TableConfig = {
    config: [
      { header: 'Estado', key: 'EstadoDocumentoTraduccion' },
      { header: 'Fecha', key: 'FechaHistorialFormateada', subtittle: 'HoraHistorialFormateada' },
      { header: 'Usuario', key: 'Usuario' },
      { header: 'Comentario', key: 'Comentarios' },
      { header: 'Estado de asociación', key: 'EstadoAsociacionFormateada', isTypeLabel: true },
      { header: 'Fecha asociación.', key: 'FechaAsociacionFormateada', subtittle: "HoraAsociacionFormateada" },
      { header: 'Usuario asociación', key: 'UsuarioAsociacion' },
      { header: 'Comentario asociación', key: 'ComentariosAsociacion' }
    ],
    accion: [],
    name: "history",
    nameMensageTable: "historial",
    initialMessage: { active: false, message: "hola" },
    delete: false,
    MensageSimple: true
  };

  dataListadoHistorial = {
    listTable: [] as HistorialFactura[],
    isOpen: false
  };

  opciones = [
    { label: 'Agregar Antes', value: -1 },
    { label: 'Agregar Después', value: 1 },
  ];

  constructor(private aprobacionService: AprobacionService, private facturaServices: FacturaService, private fb: FormBuilder, private route: ActivatedRoute,
    private helpersServices: HelpersService, private location: Location, private router: Router, private snackbarStateService: SnackbarStateService,
    private empresaService: EmpresaService, private authService: AuthService) {
    this.idOrgc = parseInt(this.route.snapshot.paramMap.get('idOrgc') || '0');
    this.idDoc = parseInt(this.route.snapshot.paramMap.get('idDoc') || '0');
    this.estadoSemaforo = this.route.snapshot.paramMap.get('estado') || '';
    this.estiloEstadoSemaforo = helpersServices.estiloEstado(this.estadoSemaforo);
    this.getDetalleFacturaPorAprobar();
    this.getListarFlujoAprobacion();
  }

  ngOnInit(): void {
    this.formulario = this.fb.group({
      comentarioAprobar: [''],
      formaPago: [''],
      comentarioRechazar: ['', Validators.required]
    });
    this.formularioEditar = this.fb.group({
      opcionSeleccionada:  [this.opciones[1].value],
      aprobador: ['', Validators.required],
      comentarioEditar:['']
    });
  }

  openHistory() {
    this.modalHistorial = true;
    this.getHistorialDocumento();
  }

  getDetalleFacturaPorAprobar() {
    this.facturaServices.obtenerDetalleFacturaPorAprobar(this.idOrgc, this.idDoc).subscribe((response: DetalleFactura) => {
      this.detalleFact = response;
      this.getBuscarInfoEmpresa();
      this.dataDetailFlujo = {
        idOrgc: this.detalleFact.IdOrgC,
        idDoc: this.detalleFact.IdDoc,
      }
      this.facturaServices.obtenerDocumentosAsociadosFacturas(this.idOrgc, this.idDoc) // 1316, 20358469
        .subscribe(
          (resDocumento: DocumentoAsociado[]) => {
            this.listDocAsociados = resDocumento;
            this.listDocAsociados.forEach(element => {
              element.disabledItem = element.CantidadAdjuntos == 0? true:false;
              element.loader = true;
              element.loaderAdjuntos = false;
              element.errorAdjuntos = false;
              element.xml = "1";
              element.FechaCreacionFormato = this.helpersServices.formatearFecha(element.FechaCreacion);
              element.DescripcionDocumentoNroDocumento = `${element.DescripcionDocumento}  ${element.NroDocumento}`;
            }
        );
        });

    });
  }

  getHistorialDocumento() {
    this.facturaServices.ObtenerHistorialDocumento((this.idOrgc), (this.idDoc)).subscribe((response: RespuestaHistorial) => {
      this.dataListadoHistorial.listTable = response.Registros;
      this.dataListadoHistorial.listTable.forEach(element => {
        element.EstadoDocumentoTraduccion = this.reemplazarGuionesBajosPorEspacios(element.EstadoDocumento);
        element.FechaAsociacionFormateada = this.helpersServices.formatearFecha(element.FechaAsociacion);
        element.FechaHistorialFormateada = this.helpersServices.formatearFecha(element.FechaHistorial);
        element.HoraAsociacionFormateada = this.helpersServices.obtenerHora(element.FechaAsociacion);
        element.HoraHistorialFormateada = this.helpersServices.obtenerHora(element.FechaHistorial);
        element.EstadoAsociacionFormateada = element.EstadoAsociacion == 'Factura_Totalmente_Asociada' ? 'Total' : 'Sin asociar';
        element.TipoLabelChips = this.helpersServices.estiloEstadoHistorialAsociacion(element.EstadoAsociacion);
      });
    });
  }

  getListarAprobadoresDisponibles() {
    this.aprobacionService.ListarAprobadoresDisponibles((this.idOrgc), (this.idDoc)).subscribe((response: AprobadorDisponible[]) => {
      this.aprobadores = response.map((aprovador: AprobadorDisponible) => {
        return {
          id: aprovador.IdUsuario.toString(),
          value: aprovador.Nombre,
          name: aprovador.Nombre
        };
      });
    });
  }

  getListarFlujoAprobacion() {
    this.aprobacionService.ListarFlujoAprobacion((this.idOrgc), (this.idDoc)).subscribe({
      next: (response: RespuestaFlujoAprobacion) => {
        this.flujoAprobacion = response;
      },
      error:(error) => {
        console.error('Error al cargar flujo:', error);
      }
    });
  }

  openModalAprobar(evt: Event) {
    this.modalAprobar = true;
  }

  openModalRechazar(evt: Event) {
    this.modalRechazar = true;
  }

  clickModalRechazar() {
    this.formulario.markAllAsTouched();
    if (this.formulario.invalid) {
    } else {
      const comentarioRechazar = this.formulario?.get('comentarioRechazar')?.value;
      const aprobarDoc = new DatosAprobarRechazar(this.idOrgc,this.idDoc,comentarioRechazar,this.authService.esUsuarioReemplazanteActivo(), 1);
      this.aprobacionService.RechazarDocumento(aprobarDoc).subscribe({
        next: (response: RespuestaAprobarRechazar) => {
          if(response.Estado){
            this.snackbarStateService.setState('Factura Rechazada', 'La Factura ha sido Rechazada con éxito.', 'success');
            this.router.navigate(['/pages/home']);
          }else{
            let mensajeError = "";
            if(response.Mensajes.length>0){
              mensajeError = response.Mensajes[response.Mensajes.length -1].Mensaje;
            }else{
              mensajeError = "";
            }
            this.snackbarStateService.setState('Error: Rechazar Factura', mensajeError, 'error');
            this.router.navigate(['/pages/home']);
          }
          
        },
        error: (error) => {
          console.error('Error al enviar la oferta:', error);
        },
        complete: () => {
          this.formulario?.controls['comentarioRechazar'].setValue("");
        }
      });
    }
  }

  clickModalAprobar() {
    const comentarioAprobar = this.formulario?.get('comentarioAprobar')?.value;
    const nuevoDocumento = new DatosAprobarRechazar(this.idOrgc,this.idDoc,comentarioAprobar,this.authService.esUsuarioReemplazanteActivo(), this.IdFormaPago);
    this.aprobacionService.AprobarDocumento(nuevoDocumento).subscribe({
      next: (response: RespuestaAprobarRechazar) => {
        if(response.Estado){
          this.snackbarStateService.setState('Factura Aprobada', 'La Factura ha sido aprobada con éxito.', 'success');
          this.router.navigate(['/pages/home']);
        }else{
          let mensajeError = "";
          if(response.Mensajes.length>0){
            mensajeError = response.Mensajes[response.Mensajes.length -1].Mensaje;
          }else{
            mensajeError = "";
          }
          this.snackbarStateService.setState('Error: Aprobar Factura', mensajeError, 'error');
          this.router.navigate(['/pages/home']);
        }
      },
      error: (error) => {
        console.error('Error al enviar la oferta:', error);
        this.typeSnackBar = "error";
        this.tituloSnackBar = "Factura Aprobada";
        this.showSnackBar = true;
        this.mensajeSnackBar = "La Factura no ha sido aprobada";
        setTimeout(() => {
          this.showSnackBar = false;
        }, 7000);
      },
      complete: () => {
        this.formulario?.controls['comentarioAprobar'].setValue("");
      }
    });
  }

  editarFlujo() {
    this.formularioEditar.markAllAsTouched();
    if (this.formularioEditar.invalid) {
      
    } else {
      const aprobador = this.formularioEditar?.get('aprobador')?.value;
      const opcionSeleccionada = this.formularioEditar?.get('opcionSeleccionada')?.value;
      const comentarioEditar = this.formularioEditar?.get('comentarioEditar')?.value;
      const nuevoAprobador = new DatosAprobador(this.idOrgc,this.idDoc,comentarioEditar,opcionSeleccionada, aprobador);
      this.aprobacionService.AgregarAprobador(nuevoAprobador).subscribe({
        next: (response: boolean) => {
          this.modalEditarFlujo = false;
          this.typeSnackBar = "success";
          this.tituloSnackBar = "Flujo Editado";
          this.showSnackBar = true;
          this.mensajeSnackBar = "El flujo ha sido editado con éxito";
          this.getListarFlujoAprobacion();
        },
        error: (err: any) => {
          this.typeSnackBar = "error";
          this.tituloSnackBar = "Flujo Editado";
          this.showSnackBar = true;
          this.mensajeSnackBar = "El flujo no ha sido editado";
        },
        complete: () => {
          this.formularioEditar?.controls['comentarioEditar'].setValue("");
        }
      });
      
    }
  }

  clikCloseModal(evt: Event) {
    this.modalRechazar = false;
    this.modalAprobar = false;
    this.modalFlujo = false;
    this.modalHistorial = false;
    this.modalEditarFlujo = false;
  }

  openModalEdit() {
    this.modalEditarFlujo = true;
    this.getListarAprobadoresDisponibles();
  }

  seleccionarAprobador(evt: any) {

  }

  back() {
    this.location.back();
  }

  closeSnackBar(event: any) {
    this.showSnackBar = false;
  }

  reemplazarGuionesBajosPorEspacios(factura: string): string {
    return factura.replace(/_/g, ' ');
  }

  
  getListarFormasPagoFactura(){
    this.facturaServices.ListarFormasPagoFactura(Financieras.Todas).subscribe((response: RespuestaFormaPago[]) => {
      this.IdFormaPago = this.detalleFact.IdFormaPagoFactura == 0? 3 : this.detalleFact.IdFormaPagoFactura;
      this.formadePago = response.map((formaPago: RespuestaFormaPago) => {
        return {
          id: formaPago.IdFormaPago.toString(),
          value: formaPago.Descripcion,
          name: formaPago.Descripcion,
          check: formaPago.IdFormaPago.toString() === this.IdFormaPago.toString()
        };
      });
      setTimeout(() => {
        this.refresSelectInputSelect.next(true);
      });
    });
  }

  getBuscarInfoEmpresa(){
    this.empresaService.BuscarInfoEmpresa(this.detalleFact.IdEmpresaC).subscribe({
      next: (response: RespuestaEmpresa) => {
        if(response){
          if(response.RegistraFormadePagoFacturas){
            this.mostrarSelectFormaPago = response.RegistraFormadePagoFacturas;
            this.getListarFormasPagoFactura();
          }
        }
      },
      error: (err) => {
        console.error("Error en getBuscarInfoEmpresa", err);
      }
    });    
  }

  seleccionarFormaPago(event: any){
    this.IdFormaPago = event; 
  }
}
